import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

import { DriveBackground } from './drive-background.component';

const rootSx: SxProps<Theme> = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const contentSx: SxProps<Theme> = {
  position: 'relative',
  zIndex: 1,
  textAlign: 'center',
  maxWidth: 440,
  px: 3,
};

export const DriveFeatureUnavailable = () => {
  const navigate = useNavigate();

  return (
    <Box sx={rootSx}>
      <DriveBackground />
      <Box sx={contentSx}>
        <Typography variant='h4' sx={{ color: 'drive.textPrimary', fontWeight: 600, mb: 1.5 }}>
          Feature Unavailable
        </Typography>
        <Typography sx={{ color: 'drive.textSecondary', mb: 3 }}>
          Insights is not available for your account. Please contact your administrator for access.
        </Typography>
        <Button variant='contained' onClick={() => navigate('/')}>
          Go to Dashboard
        </Button>
      </Box>
    </Box>
  );
};
